<template>
  <div class="card p-shadow-app">
    <div class="p-d-flex p-jc-between p-ai-center p-mb-3">
      <div>
        <h3 class="p-mb-3">
          Detalhes do PAT {{ patId }}
          <Button
            icon="pi pi-pencil"
            class="p-button-rounded p-button-text p-button-primary"
            @click="editPat()"
            v-if="can('managePATs')"
          />

          <Button
            icon="pi pi-angle-left"
            class="p-button-rounded p-button-text p-button-primary"
            @click="goToDirectionPat(false)"
            v-tooltip.bottom="'PAT Anterior'"
          />

          <Button
            icon="pi pi-angle-right"
            class="p-button-rounded p-button-text p-button-primary"
            @click="goToDirectionPat()"
            v-tooltip.bottom="'Próximo PAT'"
          />
        </h3>
      </div>

      <div>
        <a href="#" @click.prevent="toggleMenu" class="anchor-menu actions-menu" v-tooltip="'Ações'" v-if="can('seePatDetailsActions')">
          <i class="pi pi-ellipsis-h"></i>
        </a>
        <Menu ref="menu" appendTo="body" :model="actionsList" :popup="true" />
      </div>

    </div>

    <Toast />
    <TabMenu :model="menuItems" :activeIndex="activeTab" />
    <PatInfo
      v-if="activeTab === 0"
      :patId="parseInt($route.params.id)"
      :patInfo="patInfo"
    />
    <EquipmentInfo
      v-if="activeTab === 1"
      :patId="parseInt($route.params.id)"
      :equipmentInfo="patInfo.equipment"
    />
    <ClientInfo
      v-if="activeTab === 2"
      :patId="parseInt($route.params.id)"
      :clientInfo="patInfo.client"
    />
    <EntityInfo
      v-if="activeTab === 3"
      :patId="parseInt($route.params.id)"
      :entityInfo="patInfo.entity"
    />
    <Localization
      v-if="activeTab === 4"
      :patId="parseInt($route.params.id)"
    />
    <InterventionsInfo
      v-if="activeTab === 5"
      :patId="parseInt($route.params.id)"
    />
    <Files v-if="activeTab === 6" :patId="parseInt($route.params.id)" />
    <!-- Internal Dossiers List -->
    <PatDossierTab
      v-if="activeTab === 7"
      key="dossier-3"
      :patId="parseInt($route.params.id)"
    />
    <!-- Client Comments -->
    <ClientComments
      v-if="activeTab === 8"
      :patId="parseInt($route.params.id)"
    />
    <!-- Chat -->
    <ChatComponent
      v-if="activeTab === 9"
      :patId="parseInt($route.params.id)"
    />

    <!-- Integration Component -->
    <PatServiceWorkerComponent
      v-if="activeTab === 10"
      :patId="parseInt($route.params.id)"
      :brand="patInfo.oem"
      :patInfo="patInfo"
    />
    <PatNotificationLog
      v-if="activeTab === 12"
      :patId="parseInt($route.params.id)"
    />

    <PatPickup
      v-if="activeTab === 13"
      :patId="parseInt($route.params.id)"
      :patInfo="patInfo"
    />

    <PatReception
      v-if="activeTab === 14"
      :patId="parseInt($route.params.id)"
    />

    <PatShipment
      v-if="activeTab === 15"
      :patId="parseInt($route.params.id)"
      :patInfo="patInfo"
    />

    <PatAudits
      v-if="activeTab === 16"
      :patId="parseInt($route.params.id)"
    />

    <SendRequestEquipmentResources
      :show="showSendRequestEquipmentResources"
      :pat_id="patId"
      @close="showSendRequestEquipmentResources = false"
    />

    <PreviewLabelReport
      :show="showPreviewLabelReport"
      :patId="patId"
      code="label"
      @close="showPreviewLabelReport = false"
    />

    <NotifyClientDialog
      :show="showNotifyClientDialog"
      :patId="patId"
      @close="showNotifyClientDialog = false"
    />

    <PatForm
      :visible.sync="patForm.show"
      :data.sync="patForm.data"
      @cancel="closePatForm"
      @updated="patUpdated"
    />

  </div>
</template>

<script>
import PatService from "@/services/pat.service";
import PatInfo from "@/components/pats/PatInfo.vue";
import EquipmentInfo from "@/components/pats/EquipmentInfo.vue";
import ClientInfo from "@/components/pats/ClientInfo.vue";
import EntityInfo from "@/components/pats/EntityInfo.vue";
import InterventionsInfo from "@/components/pats/InterventionsInfo.vue";
import Files from "@/components/pats/PatFiles.vue";
import PatForm from "@/components/pats/PatModal.vue";
import Localization from "@/components/pats/Localization.vue";
import ClientComments from "@/components/pats/ClientComments.vue";
import ChatComponent from "../components/pats/Chat.vue"
import ChatService from "@/services/chat.service"
import PatServiceWorkerComponent from "@/components/pats/PatServiceWorkerComponent.vue";
import PatNotificationLog from "@/components/pats/PatNotificationLog.vue";
import Menu from "primevue/menu";
import portalService from "../services/portal.service";
import SendRequestEquipmentResources from "@/components/pats/SendRequestEquipmentResources.vue";
import PreviewLabelReport from "@/components/pats/PreviewLabelReport.vue";
import PatDossierTab from "@/components/internalDossier/PatDossierTab.vue";
import PatPickup from "@/components/pats/PatPickup.vue";
import PatReception from "@/components/pats/PatReception.vue";
import PatShipment from "@/components/pats/PatShipment.vue";
import PatAudits from "@/components/PatAudits.vue";
import NotifyClientDialog from "@/components/pats/NotifyClientDialog.vue";

export default {
  name: "PatDetails",
  components: {
    PatInfo,
    EquipmentInfo,
    ClientInfo,
    EntityInfo,
    InterventionsInfo,
    Files,
    PatForm,
    Localization,
    ClientComments,
    ChatComponent,
    PatServiceWorkerComponent,
    PatNotificationLog,
    Menu,
    SendRequestEquipmentResources,
    PreviewLabelReport,
    PatDossierTab,
    PatPickup,
    PatReception,
    PatShipment,
    PatAudits,
    NotifyClientDialog,
  },
  data() {
    return {
      loading: true,
      activeTab: 0,
      patId: this.$route.params.id,
      menuItems: [],
      patInfo: {},
      patForm: { show: false, data: {} },
      chatHasAlert: false,
      showSendRequestEquipmentResources:  false,
      showPreviewLabelReport: false,
      showNotifyClientDialog: false,
      actionsList: [
          {
              label: 'Ações',
              items: [
                {
                  label: 'Imprimir LABEL',
                  icon: 'pi pi-print',
                  visible: () => true,
                  command: () => this.showPreviewLabel()
                },
                {
                  label: 'Ver página solicitação de documentos',
                  icon: 'pi pi-eye',
                  visible: () => this.can("seeRequestedDocsPage"),
                  command: () => this.checkRequestedDocsPage()
                },
                {
                  label: 'Enviar solicitação de documentos',
                  icon: 'pi pi-envelope',
                  visible: () => this.can("sendRequestedDocsPage"),
                  command: () => this.sendRequestedDocsPage()
                },
                {
                  label: 'Notificar cliente',
                  icon: 'pi pi-envelope',
                  visible: () => true,
                  command: () => this.sendNotifyClient()
                }
              ]
          }
      ]
    }
  },
  computed: {},
  async mounted() {
    await this.loadPatData();
  },
  activated() {
    const newId = this.$route.params.id;
    if (newId !== this.patId) {
      this.patId = newId;
      this.activeTab = 0;
      this.loadPatData();
    }
  },
  methods: {
    async loadPatData() {
      this.loading = true;
      this.patInfo = await PatService.getInfo(this.patId) ?? {};
      this.loading = false;
      this.menuItems = [
        {
          label: "Home",
          icon: "pi pi-fw pi-home",
          command: () => this.menuClick(0),
        },
        {
          label: "Equipamento",
          icon: "pi pi-fw pi-tablet",
          command: () => this.menuClick(1),
        },
        {
          label: "Cliente",
          icon: "pi pi-fw pi-user",
          command: () => this.menuClick(2),
        },
        {
          label: "Entidade",
          icon: "pi pi-fw pi-building",
          command: () => this.menuClick(3),
          visible: () => this.patInfo.entity !== undefined,
        },
        {
          label: "Localização",
          icon: "fas fa-map-location-dot",
          command: () => this.menuClick(4),
          visible: () => this.can("seePatLocalization")
        },
        {
          label: "Intervenções",
          icon: "fas fa-screwdriver",
          command: () => this.menuClick(5),
          visible: () => this.can("seePatInterventions")
        },
        {
          label: "Ficheiros",
          icon: "fa-regular fa-file",
          command: () => this.menuClick(6),
          visible: () => this.can("seePatFiles")
        },
        {
          label: "Dossiês Internos",
          icon: "fas fa-list",
          command: () => this.menuClick(7),
          visible: () => this.can("seePatInternalDossiers"),
        },
        {
          label: "Comentários do Cliente",
          icon: "pi pi-comment",
          command: () => this.menuClick(8),
          visible: () => this.can("seeExtranetUserComments"),
        },
        {
          label: "Chat",
          icon: "pi pi-comments",
          command: () => this.menuClick(9),
          visible: () => this.can("seePatChat"),
          class: this.chatHasAlert ? "chat-tab-item has-alert" : "chat-tab-item",
          styleClass: this.chatHasAlert ? "chat-tab-item has-alert" : "chat-tab-item",
        },
        {
          label: "Ordem de Serviço",
          icon: "pi pi-fw pi-list",
          command: () => this.menuClick(10),
          visible: () => this.can("seePatServiceWorker")
        },
        {
          label: "Notificações",
          icon: "pi pi-send",
          command: () => this.menuClick(12),
          visible: () => this.can("useSmsNotifications"),
        },
        {
          label: "Recolha",
          icon: "pi pi-arrow-up",
          command: () => this.menuClick(13),
          visible: () => this.can("seePatPickup"),
        },
        {
          label: "Recepção",
          icon: "pi pi-arrow-down",
          command: () => this.menuClick(14),
          visible: () => this.can("seePatReception"),
        },
        {
          label: "Envio",
          icon: "pi pi-send",
          command: () => this.menuClick(15),
          visible: () => this.can("seePatDispatch"),
        },
        {
          label: "Auditorias",
          icon: "pi pi-history",
          command: () => this.menuClick(16),
          visible: () => this.can("seePatAudits"),
        }
      ]
      this.updateChatMenuAlert()
      if (this.can("seePatChat")) {
        await this.refreshChatNotifications()
      }
    },
    toggleMenu(event) {
      this.$refs.menu.toggle(event);
    },
    menuClick(index) {
      this.activeTab = index
      if (index === 9) {
        this.chatHasAlert = false
        this.updateChatMenuAlert()
      }
      return this.activeTab
    },
    closePatForm() {
      return (this.patForm = { show: false, data: {} });
    },
    editPat() {
      this.patForm.data = { ...this.patInfo };
      this.patForm.data.closed = this.patInfo.closed == 1 ? true : false;
      return (this.patForm.show = true);
    },
    goToDirectionPat(isNext = true) {
      let currentPatId = parseInt(this.$route.params.id);
      if (isNext) {
        currentPatId += 1;
      } else {
        currentPatId -= 1;
      }
      return PatService.getInfo(currentPatId).then(
        (adjacentPatId) => {
          if (adjacentPatId) {
            let route = this.$router.resolve({ name: "PatDetails", params: { id: currentPatId } });
            window.location.href = route.href;
          } else {
            this.$toast.add({
              severity: "info",
              summary: "Info",
              detail: "Não existem mais PATs nesta direção.",
              life: 3000,
            });
          }
        }
      );
    },
    patUpdated(pat) {
      this.patInfo = pat;
      return this.closePatForm();
    },
    async refreshChatNotifications() {
      try {
        const response = await ChatService.getMessagesNotificationsByPat(this.patId)
        const count = response
        this.chatHasAlert = count > 0
        this.updateChatMenuAlert()
      } catch (error) {
        console.warn("Erro ao carregar notificações do chat.", error)
      }
    },
    updateChatMenuAlert() {
      const chatItem = this.menuItems.find((item) => item && item.label === "Chat")
      if (chatItem) {
        const nextClass = this.chatHasAlert ? "chat-tab-item has-alert" : "chat-tab-item"
        this.$set(chatItem, "class", nextClass)
        this.$set(chatItem, "styleClass", nextClass)
      }
    },
    checkRequestedDocsPage() {
      portalService.getEncodedHash(this.patId).then((encodedHash) => {
        const route = this.$router.resolve({ name: "portalClientService", params: { hash: encodedHash } });
        window.open(route.href, '_blank');
      })
    },
    sendRequestedDocsPage() {
      this.showSendRequestEquipmentResources = true;
    },
    showPreviewLabel() {
      this.showPreviewLabelReport = true
    },
    sendNotifyClient() {
      this.showNotifyClientDialog = true;
    }
  },
}
</script>
<style scoped>
:deep(.p-tabmenu-nav) {
  flex-wrap: wrap;
}
:deep(.chat-tab-item > a) {
  position: relative;
}

:deep(.chat-tab-item.has-alert > a::after),
:deep(.chat-tab-item.has-alert > a::before) {
  content: "";
  position: absolute;
  top: 6px;
  right: 1px;
  border-radius: 9999px;
}

:deep(.chat-tab-item.has-alert > a::after) {
  width: 10px;
  height: 10px;
  background: #ef4444;
  z-index: 2;
}

:deep(.chat-tab-item.has-alert > a::before) {
  width: 16px;
  height: 16px;
  background: rgba(248, 113, 113, 0.6);
  animation: chat-tab-alert-ping 1.5s cubic-bezier(0, 0, 0.2, 1) infinite;
  z-index: 1;
}

.actions-menu {
  border: 1px solid #2196f3;
  padding: 6px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

@keyframes chat-tab-alert-ping {
  0% {
    transform: scale(0.75);
    opacity: 0.75;
  }
  75%,
  100% {
    transform: scale(1.9);
    opacity: 0;
  }
}
</style>
